// src/components/common/AppNavbar.tsx

import { useState } from "react";
import { Button, Navbar } from "react-daisyui";
import { HiArrowNarrowRight, HiMenuAlt2 } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";

import Language from "@/components/common/Language";
import Megamenu from "@/components/common/MegaMenu";
import Theme from "@/components/common/Theme";
import "@/styles/custom.css";

export default function AppNavbar({ transparent = false }: { transparent?: boolean }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);
  const navigate = useNavigate();

  // Helper to route to auth login with role parameter
  const goToDashboard = (role: string) => {
    navigate(`/auth/login?role=${role}`);
    setLoginOpen(false);
  };

  return (
    <>
      <Navbar
        className={twMerge(
          "fixed z-20",
          transparent ? "bg-base-50/40 backdrop-blur-sm" : "bg-base-100",
          "border-b border-b-base-200", 
        )}
      >
        <Navbar.Start>
          <Button
            aria-label="Open menu"
            color="ghost"
            onClick={() => setMenuOpen(true)}
            shape="circle"
          >
            <HiMenuAlt2 className="h-5 w-5" />
          </Button>

          <Link
            className="ml-2 text-2xl font-bold transition-all sm:text-2xl md:text-3xl lg:text-4xl"
            to="/"
          >
            {import.meta.env.VITE_APP_NAME || "Harehloekiseng"}
          </Link>
        </Navbar.Start>

        <Navbar.End>
          {/* Desktop Menu Items */}
          <div className="hidden gap-8 md:flex md:items-center">
            <Link className="whitespace-nowrap rounded-lg px-3 py-2 transition-all hover:bg-base-200" to="/">
              Home
            </Link>
            <Link className="whitespace-nowrap rounded-lg px-3 py-2 transition-all hover:bg-base-200" to="/pages/about-us/who-we-are">
              About
            </Link>
            <Link className="whitespace-nowrap rounded-lg px-3 py-2 transition-all hover:bg-base-200" to="/pages/about-us/for-communities">
              Services
            </Link>
            <Link className="whitespace-nowrap rounded-lg px-3 py-2 transition-all hover:bg-base-200" to="/pages/about-us/updates">
              Updates
            </Link>
            <Link className="whitespace-nowrap rounded-lg px-3 py-2 transition-all hover:bg-base-200" to="/contact-us">
              Contact Us
            </Link>
            <Link className="whitespace-nowrap rounded-lg px-3 py-2 transition-all hover:bg-base-200" to="/pages/about-us/careers">
              Careers
            </Link>
          </div>

          <Language className="mr-1 hidden sm:inline-flex" />
          <Theme className="mr-1" />

          <Button
            aria-label="Login"
            className="rounded-full px-6 font-semibold text-primary shadow-none transition-all hover:scale-105 hover:bg-base-200"
            color="ghost"
            onClick={() => navigate("/auth/login")}
          >
            <span className="flex items-center gap-2">
              <HiArrowNarrowRight className="h-5 w-5" />
              Login
            </span>
          </Button>
        </Navbar.End>
      </Navbar>
      <Megamenu onClose={() => setMenuOpen(false)} open={menuOpen} />
    </>
  );
}
